import React from 'react'

export function Alert({ children }) {
  return (
    <div style={{
      fontSize: '0.8rem',
      padding: '0.75rem 1rem',
      background: 'rgb(255 244 229)',
      borderRadius: '0.2rem',
      marginBottom: '2rem',
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      color: 'rgb(115 76 21)',
    }}>
      {children}
    </div>
  )
}
